import React from "react";
import { Disclosure } from "@headlessui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/pro-regular-svg-icons/faChevronDown";
import { faChevronUp } from "@fortawesome/pro-regular-svg-icons/faChevronUp";

import styled from "@emotion/styled";
import AccordionContent from "./AccordionContent";

let Icon = () => (
    <div className="flex items-center justify-center w-full py-10">
        <FontAwesomeIcon icon={faChevronDown} size="6x" />
    </div>
);

const FONT_SIZES = ["xs", "sm", "md", "lg", "xl", "2xl"];

const AccordionComponent = ({
    state: {
        headerColour = "#000000",
        headerHoverColour,
        headerFontWeight = "normal",
        headerFontSize = 3,
        headerBackgroundColour = "transparent",
        headerBackgroundHoverColour,
        headerFont = "body",
        borderColour = "",
        accordion = [],
        selectedAccordionIndex = 0,
    },
    isEditMode,
    focused,
    onChange,
}) => {
    const StyledHeader = styled(Disclosure.Button)`
        background-color: ${headerBackgroundColour};
        color: ${headerColour};

        &:hover {
            color: ${headerHoverColour || headerColour};
            background-color: ${headerBackgroundHoverColour ||
            headerBackgroundColour};
        }
    `;
    const inStorefront = !window?.location?.pathname.includes("/content/edit/");

    return (
        <>
            {accordion?.length > 0 ? (
                <div data-testid="accordion">
                    {accordion?.map((item, index) => (
                        <Disclosure
                            key={`accordion-${index}`}
                            defaultOpen={item.openByDefault}
                        >
                            {({ open }) => (
                                <div
                                    className={`content__accordion`}
                                    data-testid={`accordion__item-${index}`}
                                    style={{
                                        boxShadow:
                                            selectedAccordionIndex === index &&
                                            focused &&
                                            "inset 0 0 0 3px yellow",
                                        borderBottom: borderColour
                                            ? "1px solid"
                                            : "none",
                                        borderColor:
                                            borderColour || "transparent",
                                    }}
                                >
                                    <StyledHeader
                                        className={`w-full active:border-0 focus:outline-none pt-[10px] px-[15px] pb-[15px]`}
                                        {...(isEditMode && {
                                            onClick: () => {
                                                onChange({
                                                    selectedAccordionIndex:
                                                        index,
                                                });
                                            },
                                        })}
                                        style={{
                                            fontSize:
                                                FONT_SIZES[headerFontSize],
                                            fontWeight: headerFontWeight,
                                        }}
                                        data-testid={`accordion__item-${index}--header`}
                                    >
                                        <div
                                            className={` flex items-center justify-between font-bold text-lg`}
                                        >
                                            {item.label}
                                            <FontAwesomeIcon
                                                icon={
                                                    open
                                                        ? faChevronUp
                                                        : faChevronDown
                                                }
                                            />
                                        </div>
                                    </StyledHeader>

                                    <Disclosure.Panel>
                                        <div className={`my-[15px] px-[15px]`}>
                                            <AccordionContent
                                                content={item.text}
                                            />
                                        </div>
                                    </Disclosure.Panel>
                                </div>
                            )}
                        </Disclosure>
                    ))}
                </div>
            ) : inStorefront ? (
                <></>
            ) : (
                <Icon />
            )}
        </>
    );
};

export default AccordionComponent;
